<script setup lang="ts">
import { computed } from 'vue'
import { toasts, provideToast } from '@repo/ui'
import type { ToastPosition } from '@client-streamer/types/toast.type'
import AppToast from '@client-streamer/components/toast/AppToast.vue'

const positions: ToastPosition[] = ['top-right', 'top-left', 'bottom-right', 'bottom-left', 'top-center', 'bottom-center']

const groupedToasts = computed(() => {
  const groups: Record<ToastPosition, typeof toasts.value> = {
    'top-right': [],
    'top-left': [],
    'bottom-right': [],
    'bottom-left': [],
    'top-center': [],
    'bottom-center': [],
  }
  toasts.value.forEach((t) => {
    groups[t.position ?? 'top-right'].push(t)
  })
  return groups
})

provideToast()
</script>

<template>
  <slot />
  <div>
    <template v-for="pos in positions" :key="pos">
      <div
        v-if="groupedToasts[pos].length"
        :class="[
          'pointer-events-none fixed z-50 flex flex-col gap-2',
          pos === 'top-right' ? 'right-4 top-4 items-end' : '',
          pos === 'top-left' ? 'left-4 top-4 items-start' : '',
          pos === 'bottom-right' ? 'bottom-4 right-4 items-end' : '',
          pos === 'bottom-left' ? 'bottom-4 left-4 items-start' : '',
          pos === 'top-center' ? 'left-1/2 top-4 -translate-x-1/2 items-center' : '',
          pos === 'bottom-center' ? 'bottom-4 left-1/2 -translate-x-1/2 items-center' : '',
        ]"
      >
        <AppToast v-for="toast in groupedToasts[pos]" :key="toast.id" :toast="toast" class="pointer-events-auto" />
      </div>
    </template>
  </div>
</template>
